import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber } from '../../utils/generalFunctions';

import { buscarDashboard } from '../../actions/dashboard';

import MiniBarChart from '../../components/dashboard/MiniBarChart';

const DashboardAdministrador = () => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.dashboard);
    const { usuario } = useSelector(state => state.auth);

    const [dashboardData, setDashboardData] = useState({
        programas_solicitantes: null, 
        programas_beneficiarios: null, 
        apoyos_solicitantes: null, 
        apoyos_beneficiarios: null, 
        becas_solicitantes: null, 
        becas_beneficiarios: null
    });

    useEffect(() => {
        dispatch(buscarDashboard('administracion'));
    }, []);

    useEffect(() => {
        if(detalles){
            setDashboardData({
                ...dashboardData, 
                programas_solicitantes: detalles.programas_solicitantes, 
                programas_beneficiarios: detalles.programas_beneficiarios, 
                apoyos_solicitantes: detalles.apoyos_solicitantes, 
                apoyos_beneficiarios: detalles.apoyos_beneficiarios, 
                becas_solicitantes: detalles.becas_solicitantes, 
                becas_beneficiarios: detalles.becas_beneficiarios
            });
        }        
    }, [detalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .imagen_perfil {
                            height: 100px;
                            width: 100px;
                            border-radius: 50%;
                            border: 2px solid #111f62;
                            margin-right: 15px;
                        }

                        .titulo {
                            color: #111f62;
                        }

                        .indicador {
                            font-size: 18px;
                            margin: 0;
                        }

                        .subtitulo {
                            margin: 0;
                            font-weight: 700;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
        
            <div className="col-md-12 d-flex align-items-center mb-2">
                <img className="imagen_perfil" src={usuario.url_perfil_g != null ? usuario.url_perfil_g : process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'}/>
                <h4 className="titulo">
                    Bienvenido {[usuario.nombre, usuario.apellido_paterno, usuario.apellido_materno].join(' ')}
                </h4>
            </div>

            <div className="col-md-6 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Programas</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.programas_solicitantes != null && dashboardData.programas_solicitantes != undefined ? formatNumber(dashboardData.programas_solicitantes, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">solicitantes</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.programas_beneficiarios != null && dashboardData.programas_beneficiarios != undefined ? formatNumber(dashboardData.programas_beneficiarios, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">beneficiarios</p>
                            </div>
                        </div>
                        {
                            detalles ?
                                <MiniBarChart datos={[
                                    { nombre: 'Solicitantes', valor: dashboardData.programas_solicitantes || 0 },
                                    { nombre: 'Beneficiarios', valor: dashboardData.programas_beneficiarios || 0 }
                                ]} />
                            :
                                null
                        }
                    </div>
                </div>
            </div>

            <div className="col-md-6 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Apoyos</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.apoyos_solicitantes != null && dashboardData.apoyos_solicitantes != undefined ? formatNumber(dashboardData.apoyos_solicitantes, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">solicitantes</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.apoyos_beneficiarios != null && dashboardData.apoyos_beneficiarios != undefined ? formatNumber(dashboardData.apoyos_beneficiarios, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">beneficiarios</p>
                            </div>
                        </div>
                        {
                            detalles ?
                                <MiniBarChart datos={[
                                    { nombre: 'Solicitantes', valor: dashboardData.apoyos_solicitantes || 0 },
                                    { nombre: 'Beneficiarios', valor: dashboardData.apoyos_beneficiarios || 0 }
                                ]} />
                            :
                                null
                        }
                    </div>
                </div>
            </div>

            <div className="col-md-6 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Becas</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.becas_solicitantes != null && dashboardData.becas_solicitantes != undefined ? formatNumber(dashboardData.becas_solicitantes, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">solicitantes</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.becas_beneficiarios != null && dashboardData.becas_beneficiarios != undefined ? formatNumber(dashboardData.becas_beneficiarios, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">beneficiarios</p>
                            </div>
                        </div>
                        {
                            detalles ?
                                <MiniBarChart datos={[
                                    { nombre: 'Solicitantes', valor: dashboardData.becas_solicitantes || 0 },
                                    { nombre: 'Beneficiarios', valor: dashboardData.becas_beneficiarios || 0 }
                                ]} />
                            :
                                null
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardAdministrador;